export enum AppRoles {
  SuperAdmin = 'SuperAdmin',
  Admin = 'Admin',
  Member = 'Member',
  NoAccess = 'NoAccess',
  DamageApprover = 'DamageLineApprover',
  LoadAdmin = 'LoadAdmin',
  VesselViewer = 'VesselViewer',
  VesselOperator = 'VesselOperator',
  VesselManager = 'VesselManager',
  VesselAdmin = 'VesselAdmin',
  MechanicalAdmin = 'CanMechanicalUpdate',
}
